var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBackgroundProfileTwoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 632,
    height: 232,
    viewBox: "0 0 632 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_208_19603)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_19603)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -152,
    y: -83,
    width: 877,
    height: 532
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(18px)",
      clipPath: "url(#bgblur_1_208_19603_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15H598C606.284 15 613 21.7157 613 30V157H15V30C15 21.7157 21.7157 15 30 15Z",
    stroke: "#A8F0E7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_208_19603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689 -47H-116V413H689V-47Z",
    fill: "url(#paint0_linear_208_19603)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.87 242.894V41.6157H445.897V242.894H616.87Z",
    fill: "url(#paint1_linear_208_19603)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.589 242.894V89.2633H350.17V242.894H521.589Z",
    fill: "url(#paint2_linear_208_19603)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.588 89.2633V242.894H556.763L555.021 133.357L521.588 89.2633Z",
    fill: "url(#paint3_linear_208_19603)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_208_19603",
    x: 0,
    y: 0,
    width: 632,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_208_19603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_208_19603",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_208_19603_clip_path",
    transform: "translate(152 83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15H598C606.284 15 613 21.7157 613 30V157H15V30C15 21.7157 21.7157 15 30 15Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_19603",
    x1: 756.677,
    y1: 323.939,
    x2: -116.07,
    y2: -46.8348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EAE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8F0E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_208_19603",
    x1: 517.607,
    y1: 153.696,
    x2: 716.241,
    y2: -12.6108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EAE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8F0E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_208_19603",
    x1: 374.884,
    y1: 201.3,
    x2: 623.032,
    y2: 58.0142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EAE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8F0E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_208_19603",
    x1: 516.305,
    y1: 170.809,
    x2: 607.157,
    y2: 152.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8F0E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EAE9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_19603"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 30C14 21.1634 21.1634 14 30 14H598C606.837 14 614 21.1634 614 30V214H14V30Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_208_19603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 805,
    height: 460,
    fill: "white",
    transform: "translate(-116 -47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackgroundProfileTwoMobile);
export default __webpack_public_path__ + "static/media/ic-background-profile-two-mobile.d0e8ce4e5e78f6e1a7af35f94daa0297.svg";
export { ForwardRef as ReactComponent };